import { render } from "./UserBarAccounts.vue?vue&type=template&id=227a17c3"
import script from "./UserBarAccounts.vue?vue&type=script&lang=js"
export * from "./UserBarAccounts.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__